import { useState, useEffect } from "react";
import { getClientAdminOrgAdmin } from "../api/services/user";

// Keep your original async function unchanged
export async function extractOrganizationCode(
  userToken?: string | null
): Promise<string | null> {
  if (!userToken) return null;
  try {
    const base64Url = userToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const data = JSON.parse(jsonPayload);

    if (data?.user?.organizationAdminCode) {
      return data?.user?.organizationAdminCode;
    }

    return await fetchClientWay(data?.user?.clientAdminClientId);
  } catch (error) {
    return null;
  }
}

const fetchClientWay = async (clientAdminClientId) => {
  if (!clientAdminClientId) return null;
  const adminResult = await getClientAdminOrgAdmin(clientAdminClientId);
  return adminResult?.data?.organizationCode || null;
};

// Add this hook
export function useOrganizationCode(userToken?: string | null) {
  const [organizationCode, setOrganizationCode] = useState<string | null>(null);

  useEffect(() => {
    extractOrganizationCode(userToken).then((code) => {
      setOrganizationCode(code);
    });
  }, [userToken]);

  return organizationCode;
}
